<template>
    <div class="search-group template6">
        <div class="tab-header">
            <span
                v-for="(item, index) in searchGroupTabs"
                :class="`item ${activeIndex === index ? 'active' : ''}`"
                :key="item.id"
                @click="changeTab(index)"
                v-html="item.name"
            ></span>
        </div>
        <div class="tab-header mobile">
            <span
                v-for="(item, index) in searchGroupTabs"
                :class="`item ${activeIndex === index ? 'active' : ''}`"
                :key="item.id"
                @click="changeTab(index)"
                v-html="item.mobileModelName"
            ></span>
        </div>
        <div class="tab-body">
            <div
                v-for="(item, index) in searchGroupTabs"
                :key="item.id"
                :class="`tab-content ${activeIndex === index ? 'active' : ''}`"
            >
                <component
                    :is="searchBar"
                    v-if="item.inputComponentType === 'searchBar'"
                    v-show="activeIndex === index"
                    :submitText="item.submitText"
                    :placeholder="searchGroupConfig['placeholder-search']"
                    :autoSubmit="true"
                />
                <address-input
                    v-else-if="item.inputComponentType === 'addressInput'"
                    v-show="activeIndex === index"
                    :placeholder="
                        searchGroupConfig[
                            item.id === 1
                                ? 'placeholder-sell'
                                : 'placeholder-eval'
                        ]
                    "
                    icon="icon-search-medium"
                    v-model:searchText="searchText"
                    :submitText="item.submitText"
                    :chooseSuggestionAutoSubmit="false"
                    :mobileScroll="false"
                    @submitAddress="(address, data, callback) =>
                        submitAddress(
                            {address, data, callback},
                            index,
                            item.submitType,
                            item.submitUrl
                        )
                    "
                />
            </div>
        </div>
    </div>
</template>

<script>
import common from '../search-group';
import mixinsSearchBar from './mixins-search-bar';
import AddressInput from '../../../components/address-input/standard.vue';
export default {
    mixins: [common, mixinsSearchBar],
    components: {
        AddressInput
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '@/theme/mixin.scss';
.search-group.template6 {
    width: 1080px;
    margin: 0 auto;
    max-width: 100%;
    .tab-header {
        display: flex;
        width: 100%;
        justify-content: center;
        &.mobile {
            display: none;
        }

        .item {
            position: relative;
            font-family: var(--font-bold);
            cursor: pointer;
            min-width: 150px;
            text-align: center;
            height: 50px;
            line-height: 50px;
            font-size: 16px;
            white-space: nowrap;
            color: #fff;
            background-color: #252525;

            &.active {
                background-color: var(--mg-button-background);
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }

    .tab-body {
        width: 100%;
        padding: 30px;
        background-color: #252525;
        @include media-800 {
            padding: 28px 15px;
        }
        // margin-bottom: 25px;
        .tab-content {
            width: 100%;
            display: none;

            &.active {
                display: block;

                .address-input {
                    width: 100%;
                }
            }

            .search-bar {
                margin-top: 0;
            }
            .address-input {
                height: 60px;
                .left-box {
                    .input {
                        height: 60px;
                        border: 1px solid #505050;
                        border-right: none;
                        background-color: #252525;
                        color: #ababab;
                    }
                    .iconfont {
                        display: none;
                    }
                }
                .right-box {
                    .submit-btn {
                        width: 60px;
                        height: 60px;
                        line-height: 60px;
                        color: #fff;
                        @include color-button-hover();
                        @include color-button();
                        .submit {
                            display: none;
                        }
                        .iconfont {
                            font-size: 24px;
                        }
                    }
                }
            }
            > * {
                padding: 0;
                box-shadow: none;
            }
        }
    }
    @include media-800 {
        border-radius: 0;
        box-shadow: none;
        padding: 0 15px;

        .tab-header {
            display: none;
            &.mobile {
                display: flex;
                height: 50px;
                justify-content: center;
                .item {
                    min-width: 95px;
                    max-width: 115px;
                    font-size: 14px;
                    color: #fafafa;
                    font-family: var(--font-bold);
                    line-height: 50px;
                    height: 50px;
                    text-align: center;
                    @include webkitBox(1);
                }
            }
        }

        .tab-body {
            .tab-content {
                .search-bar {
                    .search-by-section {
                        border-bottom: none;
                        .search-category {
                            border: none;
                            .keyword {
                                .search-input {
                                    height: 60px;
                                    padding-left: 15px;
                                    border: 1px solid #505050;
                                    border-right: none;
                                }
                            }
                            .keyword-submit {
                                display: none;
                            }
                        }
                    }
                    > .keyword-submit {
                        display: block;
                        width: 60px;
                        height: 60px;
                        @include color-button-hover();
                        @include color-button();
                        .iconfont {
                            line-height: 60px;
                            font-size: 24px;
                            text-align: center;
                        }
                    }
                }

                .address-input {
                    box-shadow: none;
                    .left-box {
                        height: 100%;
                        .iconfont {
                            display: none;
                        }
                        .input {
                            height: 100%;
                            padding-left: 15px;
                            color: #ababab;
                            border: 1px solid #505050;
                            border-right: none;
                            background-color: #252525;
                        }
                    }
                    .right-box {
                        display: block;
                        .submit-btn {
                            width: 60px;
                            height: 60px;
                            @include color-button-hover();
                            @include color-button();
                            .submit {
                                display: none;
                            }
                            .iconfont {
                                font-size: 16px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
